/* PPS free-shipping progress bar: cart drawer + cart page. Threshold $99. */
(function () {
  if (window.__ppsShipBar) return; window.__ppsShipBar = true;
  var GOAL = 9900; // cents
  var total = null;
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function html() {
    var left = Math.max(0, GOAL - total), pct = Math.min(100, Math.round(total / GOAL * 100));
    var msg = left > 0
      ? 'You’re <b>' + money(left) + '</b> away from <b>free discreet shipping</b>'
      : '<b>You’ve unlocked free discreet shipping</b>';
    return '<p class="pps-ship__msg">' + msg + '</p><div class="pps-ship__track"><div class="pps-ship__fill" style="width:' + pct + '%"></div></div>';
  }
  function place() {
    if (total === null || total === 0) { document.querySelectorAll('.pps-ship').forEach(function (b) { b.remove(); }); return; }
    var spots = [];
    var head = document.querySelector('#CartDrawer .drawer__header'); if (head) spots.push(['after', head]);
    var page = document.querySelector('.cart__footer .cart__blocks, #main-cart-footer .cart__blocks'); if (page) spots.push(['prepend', page]);
    spots.forEach(function (s) {
      var host = s[0] === 'after' ? s[1].parentNode : s[1];
      var bar = host.querySelector(':scope > .pps-ship');
      if (!bar) { bar = document.createElement('div'); bar.className = 'pps-ship'; if (s[0] === 'after') s[1].insertAdjacentElement('afterend', bar); else host.prepend(bar); }
      var h = html(); if (bar.__h !== h) { bar.innerHTML = h; bar.__h = h; }
    });
  }
  function refresh() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { total = c.total_price; place(); }).catch(function () {});
  }
  // Refresh after any cart change made through fetch (add, change, update).
  var f = window.fetch;
  window.fetch = function (u) {
    var p = f.apply(this, arguments);
    try { var s = typeof u === 'string' ? u : (u && u.url) || ''; if (/\/cart\/(add|change|update|clear)/.test(s)) p.then(function () { setTimeout(refresh, 250); }); } catch (e) {}
    return p;
  };
  // Re-insert if the drawer re-renders and drops the bar.
  var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () {
    var head = document.querySelector('#CartDrawer .drawer__header');
    if (head && total && !head.parentNode.querySelector(':scope > .pps-ship')) place();
  }, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  var css = document.createElement('style');
  css.textContent = '.pps-ship{padding:12px 16px 14px;margin:0 0 4px;background:#fbf4f7;border-radius:12px}.drawer__header+.pps-ship{margin:0 0 8px}.pps-ship__msg{margin:0 0 8px;font-size:13px;line-height:1.4;color:#1a1a1a;letter-spacing:0}.pps-ship__msg b{color:#a3396e}.pps-ship__track{display:block!important;height:8px;border-radius:999px;background:#ecdde4;overflow:hidden}.pps-ship__fill{display:block!important;height:100%;border-radius:999px;background:#a3396e;transition:width .4s ease}';
  document.head.appendChild(css);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();

/* PPS discount links (announcement bar, banners, anywhere): apply the code in the
   background and keep the shopper where they are, instead of jumping to another page.
   The hero button has its own handler (data-pps-apply), so it is skipped here. */
(function () {
  if (window.__ppsCodeLinks) return; window.__ppsCodeLinks = true;
  var KEY = 'pps_code_applied';
  function codeFrom(a) {
    var m = (a.getAttribute('href') || '').match(/\/discount\/([^?#\/]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function mark(a, code) {
    a.textContent = '✓ ' + code + ' applied. Your discount is waiting at checkout';
    a.setAttribute('aria-disabled', 'true');
    a.style.pointerEvents = 'none';
  }
  function markAll() {
    var applied; try { applied = sessionStorage.getItem(KEY); } catch (e) {}
    if (!applied) return;
    document.querySelectorAll('a[href*="/discount/"]:not([data-pps-apply])').forEach(function (a) {
      if (codeFrom(a) === applied) mark(a, applied);
    });
    document.querySelectorAll('[data-pps-apply]').forEach(function (b) {
      if (b.getAttribute('data-pps-apply') === applied && b.textContent.indexOf('✓') !== 0) b.click && null;
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/discount/"]');
    if (!a || a.hasAttribute('data-pps-apply')) return;
    var code = codeFrom(a);
    if (!code) return;
    e.preventDefault();
    a.textContent = 'Applying ' + code + '…';
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function () {
        try { sessionStorage.setItem(KEY, code); } catch (err) {}
        document.querySelectorAll('a[href*="/discount/"]:not([data-pps-apply])').forEach(function (x) { if (codeFrom(x) === code) mark(x, code); });
      })
      .catch(function () { window.location.href = a.getAttribute('href'); });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markAll); else markAll();
})();
